import { BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import ClientRoutes from "./router/Routes";
import { Suspense } from "react";
import Loader from "./core/loader/Loader";
import "./App.scss";
import { useState } from "react";
import { useEffect } from "react";
import AnimatedCursor from "react-animated-cursor";

function App() {
  const history = createBrowserHistory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const preloadedImages = ["https://github.com/hmseeb.png"];

    cacheImages(preloadedImages);
  }, []);

  const cacheImages = async (preloadSources) => {
    const promises = await preloadSources.map((src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.src = src;
        img.onload = resolve();
        img.onerror = reject();
      });
    });

    await Promise.all(promises);
    setIsLoading(false);
  };
  return (

    <BrowserRouter history={history}>
      <div className="cursor__dot">
        <AnimatedCursor
          innerSize={15}
          outerSize={15}
          color="255, 255 ,255"
          outerAlpha={0.4}
          innerScale={0.7}
          outerScale={5}
          clickables={[
            'a',
            'input[type="text"]',
            'input[type="email"]',
            'input[type="number"]',
            'input[type="submit"]',
            'input[type="image"]',
            'label[for]',
            'select',
            'textarea',
            'button',
            '.link'
          ]}
        />
      </div>
      <Suspense fallback={<Loader />}>
        {isLoading ? <Loader /> : <ClientRoutes />}
      </Suspense>
    </BrowserRouter>

  );
}

export default App;
